import React from "react";
import PropTypes from "prop-types";
import { mapCreatorConnect } from "../../higher-order-components";
import moment from "moment";
import classNames from "classnames";
import Select from "react-select";
import { get } from "lodash";
import { DebounceInput } from "react-debounce-input";

const colors = {
  Hail: [
    {
      color: "#ffff00",
      title: "Quarter - Half Dollar",
      zIndex: 1
    },
    {
      color: "#ff5500",
      title: "Ping pong - Golf Ball",
      zIndex: 2
    },
    {
      color: "#ff0000",
      title: "Golf Ball - Tennis Ball",
      zIndex: 3
    },
    {
      color: "#5500ff",
      title: "Tennis Ball+",
      zIndex: 4
    }
  ],
  Wind: [
    {
      color: "#94a9d8",
      title: "58–73 MPH",
      zIndex: 1
    },
    {
      color: "#081f5c",
      title: "74–95 MPH",
      zIndex: 1
    },
    {
      color: "#2f6fba",
      title: "96–110 MPH",
      zIndex: 1
    },
    {
      color: "#4eadea",
      title: "110–129 MPH",
      zIndex: 1
    },
    {
      color: "#74f9fd",
      title: "130+ MPH",
      zIndex: 1
    },
    {
      color: "#000000",
      title: "Tornado",
      zIndex: 1
    }
  ]
};

class SwathEditor extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleColorSelect = this.handleColorSelect.bind(this);
    this.handleSwathMapChange = this.handleSwathMapChange.bind(this);
  }
  handleChange(prop_name, value) {
    const { current_map, current_feature } = this.props.mapCreator;
    const updated_feature = { ...current_feature };
    switch (prop_name) {
      case "houseCount":
      case "hailTime":
      case "windSpeed":
        updated_feature.properties[prop_name] = value.match(/[0-9]*/).join("");
        break;
      case "hailSize":
        updated_feature.properties[prop_name] = value.match(
          /[0-9]*\.?([0-9]+)?/g
        )[0];
        break;
      case "isolated":
        updated_feature.properties.isolated =
          current_feature.properties.isolated == true ? false : true;
        break;
      case "removeTornadoEFRank":
        current_feature.properties.tornadoEFRank = 0;
        break;
      case "fillColor":
        const color_option = colors[
          get(current_map, "properties.mapType", "Hail")
        ].find(c => c.color == value.color);
        if (!color_option) {
          throw new Error("Invalid color option");
        }
        if (color_option.title === "Tornado") {
          current_feature.properties.tornadoEFRank = 0;
        } else {
          current_feature.properties.tornadoEFRank = undefined;
        }
        updated_feature.properties.fillColor = color_option.color;
        updated_feature.properties.zIndex = color_option.zIndex;
        break;
      default:
        updated_feature.properties[prop_name] = value;
        break;
    }

    const { _id: map_id } = current_map || {};
    this.props.updateCurrentMapFeature(updated_feature, map_id);
  }
  handleColorSelect(color_option) {
    event.preventDefault();
    this.handleChange("fillColor", color_option);
  }
  handleSwathMapChange({ value: new_map }) {
    const { current_map, current_feature } = this.props.mapCreator;
    const payload = {
      to_map_id: new_map,
      from_map_id: current_map._id,
      feature_id: current_feature.properties._id
    };
    this.props.sendSocketEmit(payload, "move-map-feature");
  }

  render() {
    const { current_feature, maps_list, current_map } = this.props.mapCreator;

    const mapType = get(current_map, "properties.mapType", "Hail");

    return (
      <div>
        <h3 className="title">{mapType} Swath Editor</h3>
        <div className="row">
          <div className="col-xs-12">
            <p className="title">Parent Map</p>
            <Select
              options={maps_list.map(m => ({
                value: m._id,
                label: m.properties.title
              }))}
              value={current_map._id}
              clearable={false}
              onChange={this.handleSwathMapChange}
            />
          </div>
        </div>
        <div className="form clearfix">
          <p className="title">
            {mapType === "Wind" ? "Wind Speed" : "Hail Size"}
          </p>
          <div className="map-color-options clearfix">
            {colors[mapType].map((option, idx) => {
              const options_class = classNames("map-color-option", {
                selected: current_feature.properties.fillColor == option.color
              });
              return (
                <div
                  key={idx}
                  data-key={idx}
                  className={options_class}
                  onClick={() => this.handleColorSelect(option)}
                >
                  <div
                    className="color-swath"
                    style={{ background: option.color }}
                  ></div>
                  <h5>{option.title}</h5>
                </div>
              );
            })}
          </div>
          <hr className="separator" />
          <p className="title">Details</p>
          <div className="form-group">
            <div className="row">
              <div className="col-xs-12 control-label">{mapType} Time</div>
              <div className="col-xs-12">
                <DebounceInput
                  type="text"
                  element="input"
                  onChange={e => {
                    this.handleChange(
                      `${mapType.toLowerCase()}Time`,
                      e.target.value
                    );
                  }}
                  debounceTimeout={100}
                  className="form-control"
                  placeholder="Minutes"
                  value={
                    current_feature.properties[`${mapType.toLowerCase()}Time`]
                  }
                />
              </div>
              {() => {
                const duration = moment.duration({
                  minutes: Number(current_feature.properties.hailTime)
                });
                if (duration) {
                  const minutes = duration.minutes();
                  const hours = duration.hours();
                  const output =
                    (hours > 0 ? hours + " hours " : "") +
                    (minutes > 0 ? minutes + " minutes" : "");

                  return (
                    <div className="col-xs-12">
                      <p>{output}</p>
                    </div>
                  );
                }
              }}
            </div>
          </div>

          {typeof current_feature.properties.tornadoEFRank === "number" ? (
            <div className="form-group">
              <div className="row">
                <div className="col-xs-12 control-label">EF Ranking</div>
                <div className="col-xs-12">
                  <Select
                    options={[0, 1, 2, 3, 4, 5].map(value => ({
                      label: value,
                      value
                    }))}
                    onChange={e => {
                      e === null
                        ? this.handleChange("removeTornadoEFRank")
                        : this.handleChange("tornadoEFRank", e && e.value);
                    }}
                    value={current_feature.properties.tornadoEFRank}
                  />
                </div>
                <div className="col-xs-12">
                  {current_feature.properties.tornadoEFRank}
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="form-group">
                <div className="row">
                  <div className="col-xs-12 control-label">Wind Speed</div>
                  <div className="col-xs-12">
                    <DebounceInput
                      type="text"
                      onChange={e =>
                        this.handleChange("windSpeed", e.target.value)
                      }
                      className="form-control"
                      placeholder="MPH"
                      value={current_feature.properties.windSpeed}
                      debounceTimeout={100}
                    />
                  </div>
                  {Number(current_feature.properties.windSpeed) > 0 ? (
                    <div className="col-xs-12">
                      <p>
                        {current_feature.properties.windDirection + " "}
                        {Number(
                          current_feature.properties.windSpeed
                        ).format()}{" "}
                        MPH
                      </p>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col-xs-12 control-label">Wind Direction</div>
                  <div className="col-xs-12">
                    <Select
                      options={[
                        "N",
                        "S",
                        "E",
                        "W",
                        "NE",
                        "NW",
                        "SE",
                        "SW"
                      ].map(value => ({ label: value, value }))}
                      onChange={e =>
                        this.handleChange("windDirection", e && e.value)
                      }
                      value={current_feature.properties.windDirection}
                    />
                  </div>
                  <div className="col-xs-12">
                    {current_feature.properties.windDirection}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="form-group">
            <div className="row">
              <div className="col-xs-12 control-label">House Count</div>
              <div className="col-xs-12">
                <DebounceInput
                  type="text"
                  onChange={e =>
                    this.handleChange("houseCount", e.target.value)
                  }
                  className="form-control"
                  placeholder="House Count"
                  value={current_feature.properties.houseCount}
                  debounceTimeout={100}
                />
              </div>
              {Number(current_feature.properties.houseCount) > 0 ? (
                <div className="col-xs-12">
                  <p>
                    {Number(current_feature.properties.houseCount).format()}{" "}
                    Houses
                  </p>
                </div>
              ) : null}
            </div>
          </div>
          {mapType === "Hail" && (
            <div className="form-group">
              <div className="row">
                <div className="col-xs-12 control-label">Hail Size</div>
                <div className="col-xs-12">
                  <DebounceInput
                    type="number"
                    onChange={e =>
                      this.handleChange("hailSize", e.target.value)
                    }
                    className="form-control"
                    placeholder="Inches"
                    value={current_feature.properties.hailSize}
                    debounceTimeout={100}
                  />
                </div>
              </div>
            </div>
          )}
          {current_feature.properties.hailSize &&
          current_feature.properties.hailSize != "" ? (
            <div className="col-xs-12">
              <p>{current_feature.properties.hailSize}&quot;</p>
            </div>
          ) : null}
          <div className="row mb-md">
            <div className="col-xs-12">
              <div className="checkbox-custom checkbox-default">
                <DebounceInput
                  type="checkbox"
                  onChange={() => this.handleChange("isolated")}
                  checked={current_feature.properties.isolated}
                  id="isolated-checkbox"
                  debounceTimeout={100}
                />
                <label htmlFor="isolated-checkbox">Isolated</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default mapCreatorConnect(SwathEditor);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/swath-editor.js